module.exports = __webpack_public_path__ + "img/bnjmwjm.be3bec03.png";